module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-4-1.6a56c323.png";